// extracted by mini-css-extract-plugin
module.exports = {"stat":"stat__-R8ai"};